import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import {
  countActivities,
  createBulkActivity,
  createItemLogActivity,
  searchActivities,
  getItemLog,
  search,
} from "../api/ProjectApi";
import { defaultActivity, defaultEmail } from "../reducers/activityReducer";
import { saveDraftEmail } from "../api/EmailApi";

const api = {
  [ActionTypes.createActivity]: (itemId, data) => {
    if (itemId) {
      return createItemLogActivity(itemId, data);
    } else {
      return createBulkActivity(data);
    }
  },
  [ActionTypes.showActivityDialog]: (itemId, activityId, data) => {
    if (itemId && activityId) {
      return getItemLog(itemId, activityId);
    }
    return {
      ...defaultActivity,
      itemId,
      event: {
        ...defaultActivity.event,
        data: {
          ...defaultActivity.event.data,
          ...data,
        },
      },
    };
  },
  [ActionTypes.changeActivityData]: (fieldId, fieldValue) => ({
    fieldId,
    fieldValue,
  }),
  [ActionTypes.searchActivities]: (query) => searchActivities(query),
  [ActionTypes.countMyDueOverActivities]: (query) => countActivities(query),
  [ActionTypes.hideActivityDialog]: () => ({}),
  [ActionTypes.resetActivityDialog]: (data) => ({ data }),
  [ActionTypes.changeFiltersUpcomingChrome]: (data) => ({ data }),
  [ActionTypes.searchUpcomingChrome]: (projectId, filters) => {
    return search({
      projectId: projectId,
      pageSize: 50,
      types: ["ACTIVITY"],
      filters: filters,
    });
  },
  [ActionTypes.showActivityDialogChrome]: (itemId, activityId, data) => {
    if (itemId && activityId) {
      return getItemLog(itemId, activityId);
    }
    return {
      ...defaultActivity,
      itemId,
      event: {
        ...defaultActivity.event,
        data: {
          ...defaultActivity.event.data,
          ...data,
        },
      },
    };
  },
  [ActionTypes.hideActivityDialogChrome]: () => ({}),
  [ActionTypes.changeEmailData]: (fieldId, fieldValue) => ({
    fieldId,
    fieldValue,
  }),
  [ActionTypes.showEmailDialog]: (workspaceId, data) => {
    if (data) {
      return {
        ...defaultEmail,
        ...data,
      };
    }
    return saveDraftEmail(workspaceId, defaultEmail);
  },
  [ActionTypes.hideEmailDialog]: () => ({}),
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
